var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShaa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.303 756.6c-9.586 1.253-21.044-11.13-7.344-14.66 43.69-8.445 191.763-31.914 208.715-38.97 14.882-4.476 48.78 19.646 69.772 30.824 13.035 7.626 7.097 16.274-2.938 20.175-8.125 2.447-55.98 6.847-81.613 3.759-4.89-.5-3.035-12.309-13.956-14.002-50.104-9.31-121.715 6.609-172.636 12.874Z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.85009 0 0 .93539 19.53 -595.253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3 755.155c-1.275 3.789-1.924 9.06-4.622 10.318-5.18 1.776-10.933.562-13.808 5-4.19 6.732-29.81 25.813-47.58 39.893-5.04 3.992-13.56 1.057-14.11-6.386l-.068 27.464 12.62-.624c10.987-8.589 41.279-37.359 54.83-37.696 10.772-.855 23.242-4.166 26.21-11.339 2.5-6.407-4.914-10.93-4.229-14.504 1.07-4.177 9.936-8.481 12.91-8.514 5.076-.056-20.883-7.645-22.152-3.612z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.85009 0 0 .93539 19.53 -595.253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.513 845.652c52.142-12.4 175.205-50.85 193.237-43.657 22.34 10.87 63.544 36.445 64.115 47.242.226 10.504.098 11.397-8.759 19.874-13.17 12.93-55.353 77.186-61.499 101.906-1.422 6.271-.443 18.401-5.167 23.428-6.613 7.365-88.046-1.13-141.056-3.23-17.92-.6-26.244-18.982.533-19.54 34.106-.614 92.368-2.022 99.276-10.493 6.239-7.953 49.264-97.451 49.364-107.09.106-6.046-10.735-20.21-17.193-24.295-7.881-5.57-118.387 28.03-167.578 35.02z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.85009 0 0 .93539 19.53 -595.253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79 858.993c13.914 26.906 43.91 76.585 55.89 124.515l32.084-2.126c-7.936-36.068-27.317-97.355-46.123-127.42-33.87-53.702-70.167-46.594-41.851 5.031Zm98.374-75.07c-3.212-15.545-15.495-12.916-13.587 3.497l18.464 193.393 14.143-.7zm68.493 1.193h-13.324l-25.127 191.878h12.92z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.85009 0 0 .93539 19.53 -595.253)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaa);
export default __webpack_public_path__ + "static/media/Shaa.b3efd6ce3c51e80140ab139964c75af1.svg";
export { ForwardRef as ReactComponent };